import script from "./GameEffect.vue?vue&type=script&setup=true&lang=js"
export * from "./GameEffect.vue?vue&type=script&setup=true&lang=js"

import "./GameEffect.vue?vue&type=style&index=0&id=55a1c0b7&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-55a1c0b7"]])

export default __exports__